<script setup>
import { PopoverArrow } from "reka-ui";

const props = defineProps({
  width: { type: Number, required: false, default: 10 },
  height: { type: Number, required: false, default: 5 },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  rounded: { type: Boolean, required: false },
  class: { type: null, required: false },
});
</script>

<template>
  <PopoverArrow
    data-slot="popover-arrow"
    :width="props.width"
    :height="props.height"
    :rounded="props.rounded"
    :as-child="props.asChild"
    :as="props.as"
    :class="props.class"
    class="fill-popover"
  />
</template>
